export default {
      id: "toast-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#toast-usage",
      toString: function () {
        return this.url;
      }
    }